import { IExpenses, IViewFactFindExpenditureEx } from '@zeta-types';
import { expenditureDefault } from './form-helpers';

interface IExpenseDetailConfig {
  detail: string;
  amountField: keyof IExpenses;
  infoField: keyof IExpenses;
}

export const transformExpenditureData = (expenditure: IViewFactFindExpenditureEx, ffConfig: any) => {
  const showField = (ffConfig: any, type: string | undefined) => {
    if (!type) return true;

    const fieldMapping = {
      mortgage: 'mortgage',
      rent: 'rent',
      counciltax: 'councilTax',
      electricity: 'electricity',
      gas: 'gas',
      water: 'water',
      broadband: 'phoneTvBroadband',
      insurancepremiums: 'insurancePremiums',
      schoolfees: 'childrenSchoolFees',
      householdmaintenance: 'householdMaintenance',
      food: 'food',
      clothes: 'clothes',
      carinsurance: 'carInsurance',
      fuel: 'carFuelAndMaintenance',
      holiday: 'travelHolidayTrips',
    };

    for (const [key, value] of Object.entries(fieldMapping)) {
      if (type.includes(key)) {
        return ffConfig?.fields?.[value]?.active ?? true;
      }
    }

    return true;
  };

  const mapExpenditureConfig = (item: any) => {
    return {
      id: item?.id || '',
      detail: item?.expenditureType || '',
      category: item?.expenditureCategory || '',
      vendorName: item?.venderName || '',
      amount: item?.amount || null,
      frequency: item?.frequency || '',
      paymentMethod: item?.paymentMethod || '',
      dueDate: item?.dueDate || '',
      notes: item?.notes || '',
      show: showField(ffConfig, item?.expenditureType?.split(' ').join('').toLowerCase()) ?? true,
    };
  };

  const transformExpenseData = (expense: any) => {
    const transformedData = expense?.map((e) => mapExpenditureConfig(e));
    return expense?.length > 0 ? transformedData : expenditureDefault(ffConfig);
  };

  return {
    client: transformExpenseData(expenditure?.clientExpense),
    partner: transformExpenseData(expenditure?.partnerExpense),
    joint: transformExpenseData(expenditure?.jointExpense),
  };
};
